export default __webpack_public_path__ + "static/media/callIcon.e9365410.svg";